import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const CostNoItSupport2 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costNoItSupport" section="downtimeMeaning">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costNoItSupport:downtimeMeaning" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CostNoItSupport2;
